// Cab/Vehicle Category Constants for FusionCab - Backend Compatible

export const CAB_TYPES = {
  HATCHBACK: "Hatchback",
  SEDAN: "Sedan",
  SUV: "SUV",
} as const;

export type CabType = (typeof CAB_TYPES)[keyof typeof CAB_TYPES];

export const CAB_TYPE_OPTIONS: { value: CabType; label: string }[] =
  Object.values(CAB_TYPES).map((value) => ({ value, label: value }));
